import Vue from 'vue'
import App from './App.vue'
import router from './router'
import * as filters from './filters' // global filters
import VueHead from 'vue-head'
import vSelect from 'vue-select'

Vue.component('v-select', vSelect)
import 'vue-select/dist/vue-select.css';
Vue.use(VueHead)

import VueNavigationBar from 'vue-navigation-bar';
import 'vue-navigation-bar/dist/vue-navigation-bar.css';

Vue.component('vue-navigation-bar', VueNavigationBar);

//require('datejs')

import { ModalPlugin, CollapsePlugin, BreadcrumbPlugin ,ToastPlugin, SpinnerPlugin ,CarouselPlugin, PaginationPlugin  , IconsPlugin  } from 'bootstrap-vue'

// Import Bootstrap and BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Make BootstrapVue available throughout your project
Vue.use(ModalPlugin)
Vue.use(CollapsePlugin)
Vue.use(BreadcrumbPlugin)
Vue.use(ToastPlugin)
Vue.use(SpinnerPlugin)
Vue.use(CarouselPlugin)
Vue.use(PaginationPlugin)

// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

import VueGlide from 'vue-glide-js'
import 'vue-glide-js/dist/vue-glide.css'

import './assets/styles/tailwind.css'
import './assets/styles/global.scss'
import './assets/styles/v_main.scss'


Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
